import React from 'react'
import { Container, CountryCode, LocationIcon, Name } from './City.style'
import { City as ICity } from '../../cities.const'
import { useTranslation } from 'react-i18next'

interface Props {
    city: ICity
    onClick: (city: ICity) => void
}

const City: React.FC<Props> = ({ city, onClick }) => {
    const { t } = useTranslation()
    return (
        <Container
            onClick={() => {
                onClick(city)
            }}
        >
            <LocationIcon className="wemolo-location-2" />
            <div>
                <Name>{t(city.name)}</Name>
                <CountryCode>{city.countryCode}</CountryCode>
            </div>
        </Container>
    )
}

export default City
